<template lang="html">

  <div class="actualidad--view actualidad">

    <intro></intro>

    <noticias></noticias>

    <videos></videos>

    <twitter></twitter>

    <otras-secciones :data="['sala_prensa','catalogo']"></otras-secciones>


  </div>

</template>

<script lang="js">


  import Intro from '@/components/view-parts/intros/actualidad'

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';
  
  import Noticias from '@/components/view-parts/actualidad-parts/noticias';
  import Videos from '@/components/view-parts/actualidad-parts/videos';
  import Twitter from '@/components/view-parts/actualidad-parts/twitter';

  export default  {
    name: 'actualidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
    },
    components: {
      'noticias' : Noticias,
      'videos' : Videos,
      'twitter' : Twitter,
      'intro' : Intro,
      'otras-secciones' : Otras_Secciones

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/actualidad.vue